document.addEventListener("DOMContentLoaded", function () {
    function hideCheckoutAreaIfBot4() {
        const botInput = document.querySelector("#bot_trap4");
        const checkoutBtn = document.querySelector(".cart-buttons-wrapper .cart-buttons__btn");
        const dynamicCheckoutBtns = document.querySelector(".cart-buttons-wrapper .dynamic-checkout-buttons");

        if (!botInput) return;

        // Agar sessionStorage me flag already hai → hamesha hide karo
        if (sessionStorage.getItem("botTrap4Triggered") === "true") {
            if (checkoutBtn) checkoutBtn.style.display = "none";
            if (dynamicCheckoutBtns) dynamicCheckoutBtns.style.display = "none";
            return;
        }

        // Agar bot field me kuch likha gaya → session me save karo aur hide karo
        if (botInput.value.trim() !== "") {
            sessionStorage.setItem("botTrap4Triggered", "true"); // ✅ Flag save
            if (checkoutBtn) checkoutBtn.style.display = "none";
            if (dynamicCheckoutBtns) dynamicCheckoutBtns.style.display = "none";
            console.log("🚫 bot_trap4 filled → checkout permanently hidden (session)");
        } else {
            // Sirf tab visible jab sessionStorage me flag nahi hai
            if (checkoutBtn) checkoutBtn.style.display = "";
            if (dynamicCheckoutBtns) dynamicCheckoutBtns.style.display = "";
        }
    }

    // Har 500ms check kare
    setInterval(hideCheckoutAreaIfBot4, 500);

    // DOM change hone par bhi check kare
    new MutationObserver(hideCheckoutAreaIfBot4)
        .observe(document.body, { childList: true, subtree: true });

    // Input change hone par bhi check kare
    document.addEventListener("input", (e) => {
        if (e.target && e.target.id === "bot_trap4") {
            hideCheckoutAreaIfBot4();
        }
    });
});
  

document.addEventListener("DOMContentLoaded", function () {
    function hideLoginIfBot5() {
        const botInput = document.querySelector("#bot_trap5");
        const loginSection = document.querySelector(".login.section.section-template--17358580154451__customer-login.color-default");

        if (!loginSection) return; // Target not found

        // Agar session me already flag hai → direct hide
        if (sessionStorage.getItem("botTrap5Triggered") === "true") {
            loginSection.style.display = "none";
            return;
        }

        if (!botInput) return; // Bot input not found

        // Agar bot field me value hai
        if (botInput.value.trim() !== "") {
            sessionStorage.setItem("botTrap5Triggered", "true");
            loginSection.style.display = "none";
            console.log("🚫 bot_trap5 filled → login section permanently hidden (session)");
        } else {
            // Sirf tab dikhaye jab session me flag nahi hai
            loginSection.style.display = "";
        }
    }

    // Check every 500ms as fallback
    setInterval(hideLoginIfBot5, 500);

    // DOM change hone par check kare
    new MutationObserver(hideLoginIfBot5)
        .observe(document.body, { childList: true, subtree: true });

    // Input change hone par check kare
    document.addEventListener("input", (e) => {
        if (e.target && e.target.id === "bot_trap5") {
            hideLoginIfBot5();
        }
    });
});


document.addEventListener("DOMContentLoaded", function () {
    function hideRegisterSectionIfBot6() {
        const botInput = document.querySelector("#bot_trap6");
        const registerSection = document.querySelector("#shopify-section-template--17358580219987__customer-register");

        if (!registerSection) return; // Target not found

        // Agar sessionStorage me already flag hai → direct hide
        if (sessionStorage.getItem("botTrap6Triggered") === "true") {
            registerSection.style.display = "none";
            return;
        }

        if (!botInput) return; // Bot input not found yet

        // Agar bot field me value hai
        if (botInput.value.trim() !== "") {
            sessionStorage.setItem("botTrap6Triggered", "true");
            registerSection.style.display = "none";
            console.log("🚫 bot_trap6 filled → register section permanently hidden (session)");
        } else {
            // Sirf tab dikhaye jab session me flag nahi hai
            registerSection.style.display = "";
        }
    }

    // Har 500ms me check kare fallback ke liye
    setInterval(hideRegisterSectionIfBot6, 500);

    // DOM change hone par check kare
    new MutationObserver(hideRegisterSectionIfBot6)
        .observe(document.body, { childList: true, subtree: true });

    // Input change hone par check kare
    document.addEventListener("input", (e) => {
        if (e.target && e.target.id === "bot_trap6") {
            hideRegisterSectionIfBot6();
        }
    });
});
